import React from 'react';
import TopProblemsSection from './TopProblems';
import { Link } from 'react-router-dom';
import RippleGrid from '../backgroundi/RippleGrid';
import { Dashboard, Login } from '@mui/icons-material';
import { shortLogo } from '../config/config';
import InfoLists from './InfoLists';
import SEO, { seoConfig } from './SEO';
import ImageGenerateAds from '../Ads/ImageGenerateAds';


const howItWorks = [
     { id: '01', title: 'Publish ideas privately & publicly', desc: 'Capture raw concepts instantly in your personal vault.', tag: 'Private', meta: 'Draft' },
     { id: '02', title: 'Publish problem privately & publicly', desc: 'Turn rough thoughts into structured public idea pages.', tag: 'Public', meta: 'Clean' },
     { id: '03', title: 'Get feedback', desc: 'See reactions and validation signals before investing time.', tag: 'Signal', meta: '92% positive' },
     { id: '04', title: 'Find collaborators', desc: 'Connect with makers genuinely interested in building.', tag: 'Team', meta: '+24 joins' },
];

const features = [
     { title: 'Private Idea Vault', desc: 'Encrypted space for unfinished concepts and rough notes.', cue: 'Security' },
     { title: 'Public Idea Sharing', desc: 'Beautifully structured pages ready for the world.', cue: 'Sharing' },
     { title: 'Collaboration Requests', desc: 'Let developers and designers apply to help build.', cue: 'Coming Soon' },
     { title: 'Idea Validation', desc: 'Collect signals through comments and validation scores.', cue: 'Analytics' },
];

function Homepage() {

     const auth = JSON.parse(localStorage.getItem('auth'));

     return (
          <>
               <SEO {...seoConfig.home} />

               <div className="forge-light-theme">

                    <section className="forge-hero">
                         <div className="forge-hero-shapes" aria-hidden="true">
                              <span className="hero-shape hero-shape-orb"></span>
                              <span className="hero-shape hero-shape-diamond"></span>
                              <span className="hero-shape hero-shape-ring"></span>
                              <span className="hero-shape hero-shape-triangle"></span>
                              <span className="hero-shape hero-shape-pill"></span>
                         </div>

                         <div className='__bg_item'>
                              <RippleGrid
                                   enableRainbow={false}
                                   gridColor="#000000"
                                   rippleIntensity={0.05}
                                   gridSize={15}
                                   gridThickness={15}
                                   mouseInteraction={true}
                                   mouseInteractionRadius={1.2}
                                   opacity={0.08}
                              />
                         </div>

                         <div className="forge-container">
                              <div className="forge-hero-content">
                                   <span className="forge-badge">New: Collaboration Mode</span>
                                   <h1>Validate your ideas with real people before you build.</h1>
                                   <p>Turn your ideas and the problems behind them into something real by testing them with real people before investing time or money. Share your idea or problem, get honest feedback, discover improvements, and move forward with confidence validated by real users.</p>

                                   <div className="forge-actions heading-font">
                                        {auth ?
                                             <Link to="/overview" className="forge-btn-primary"> <Dashboard /> Overview</Link>
                                             :
                                             <Link to="/login" className="forge-btn-primary"> <Login /> Start Register Free</Link>
                                        }

                                        <Link to="/explore" className="forge-btn-secondary">View Showcase</Link>
                                   </div>


                                   <InfoLists />


                              </div>
                         </div>
                    </section>

                    {/* How it Works - Simple Grid */}
                    <section className="forge-section bg-alt" id="features">
                         <div className="forge-container">
                              <div className="forge-header-center">
                                   <label>Workflow</label>
                                   <h2>Simple steps to momentum</h2>
                              </div>

                              <div className="row row-gap-3">
                                   <div className='col-12'>
                                        <ImageGenerateAds />
                                   </div>

                                   {howItWorks.map(step => (
                                        <div className='col-md-3' key={step.id}>
                                             <div className="forge-step-card">
                                                  <div className="step-num">{step.id}</div>
                                                  <h3>{step.title}</h3>
                                                  <p>{step.desc}</p>
                                             </div>
                                        </div>
                                   ))}


                              </div>
                         </div>
                    </section>

                    <TopProblemsSection />

                    {/* Features - Clean Minimal Cards */}
                    <section className="forge-section forge-feature-section">
                         <div className="forge-container">
                              <div className="forge-feature-shell">
                                   <div className="forge-feature-lead">
                                        <span className="forge-feature-kicker">Inside The Forge</span>
                                        <h2>A product room for ideas that are still taking shape.</h2>
                                        <p>Instead of a plain feature list, this space is built like a creative control board: private drafting, public launch, collaborator discovery, and validation signals all in one flow.</p>

                                        <div className="forge-feature-pulse">
                                             <div>
                                                  <strong>4</strong>
                                                  <span>Core systems</span>
                                             </div>
                                             <div>
                                                  <strong>Live</strong>
                                                  <span>Momentum tracking</span>
                                             </div>
                                        </div>
                                   </div>

                                   <div className="forge-feature-board">
                                        {features.map((f, index) => (
                                             <article key={f.title} className={`forge-feature-item feature-card-${index + 1}`}>
                                                  <div className="forge-feature-meta">
                                                       <span className="forge-feature-index">{`0${index + 1}`}</span>
                                                       <span className="forge-feature-cue">{f.cue}</span>
                                                  </div>
                                                  <h3>{f.title}</h3>
                                                  <p>{f.desc}</p>
                                                  <div className="forge-feature-trace" aria-hidden="true">
                                                       <span></span>
                                                       <span></span>
                                                       <span></span>
                                                  </div>
                                             </article>
                                        ))}
                                   </div>
                              </div>
                         </div>
                    </section>

                    {/* Simple CTA */}
                    <section className="forge-cta" id="cta">
                         <div className="forge-container">
                              <div className="forge-cta-box">
                                   <img src={shortLogo} alt="Haveidea Logo" />
                                   <h2>Ready to build?</h2>
                                   <p>Join 2,000+ builders capturing ideas today.</p>
                                   <Link to="/submit" className="forge-btn-primary-light">Create Your First Idea</Link>
                              </div>
                         </div>
                    </section>
               </div>
          </>

     );
}

export default Homepage;
